module.exports = __webpack_public_path__ + "img/01.a67d946b.png";